<!-- Chronometre.svelte -->

<script>
  import { onMount } from "svelte";
  import { urlServeur, pathFilesSport } from "./conf.js";
  import Spinner from "../components/ihm/ToolsSpinner.svelte";

  let timeExec = 20;
  let timeRepos = 10;
  let seconds = 0;
  let secondes = [timeExec, timeRepos];
  let intervalId = null;
  let i = 0;
  let y = 1; // l'indec x 0 est utiliser pour la premiree image
  let classChrono = ["exec", "repos"];
  let chrono = classChrono[0];
  let brutRows = [];
  let photo;
  let tabSelectImage = [];
  let maxImg = 4;
  let visible= false;
  /**
   * depart du chrono
   */
  function start() {
    seconds = secondes[i];
    photo = brutRows[tabSelectImage[y - 1]]; // image de départ

    //console.log("xxx" + photo);

    // dépar boucle temps pour le chrono
    intervalId = setInterval(() => {
      seconds--;

      if (seconds === 0) {
        i++;
        if (i > 1) i = 0;
        seconds = secondes[i]; // alterne entre les 2 temps exec et repos
        chrono = classChrono[i]; // affiche la couleur en fonction du crono
        if (i == 0) {
          y++;
          if (y > tabSelectImage.length) {
            y = 1;
          }
          photo = brutRows[tabSelectImage[y - 1]]; // change  d'images pour un nouveau chrono exec
        }
        //console.log("Chronomètre : ça fait 20 secondes !");
      }
    }, 1000);
  }

  /**
   *
   */
  function stop() {
    clearInterval(intervalId);
  }

  /**
   *
   */
  function reset() {
    clearInterval(intervalId);
    seconds = secondes[0];
  }

  /**
   * Récupere les images sur le serveur
   */
  const fetchData = async () => {
    const response = await fetch(
      urlServeur + "/api/permis/contenuDossierImage/sport"
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error("unable to load liste images  ");
        }
        return response.json();
      })
      .then(function (data) {
        brutRows = data.payload;
        //console.log(brutRows);
        tabSelectImage = tableauAleatoire(brutRows, maxImg);
        start();
      });
  };

  /**
   *
   * @param creation d un tableau d'index aleatoire pour le tableau images
   */
  const tableauAleatoire = (tabImg, maxImg = 4) => {
    let leTab = [];
    let nbre = -9;
    let i = 0;

    while (leTab.length < maxImg) {
      nbre = Math.floor(Math.random() * (20 - 0 + 1)) + 0;

      if (leTab.indexOf(nbre) === -1) {
        leTab.push(nbre);
      }

      i++;
    }
    //console.log(leTab);
    return leTab;
  };

  $: secondes = [timeExec, timeRepos];
  $: tabSelectImage = tableauAleatoire(brutRows, maxImg);

  onMount(() => {
    fetchData();
    // start();
  });
</script>

<h1 class={chrono} style=" text-align: center;">
  <span class="compteur">{y}</span> -
  <span class="chiffre">{seconds.toString().padStart(2, "0")}</span>
</h1>
<button class="btnchrono" on:click={start}>Start</button>
<button class="btnchrono" on:click={stop}>Stop</button>
<button class="btnchrono" on:click={reset}>Reset</button>
<button class="btnchrono" on:click={() => (visible = !visible)}>Show</button>


<div class="container">
  <div style=" text-align: center;">
    <table class="table table-bordered table-sm">
      <tr>
        <td>Nbr: <input bind:value={maxImg} size="4" /></td>
        <td>exec: <input bind:value={timeExec} size="4" /></td>
        <td>repos : <input bind:value={timeRepos} size="4" /></td>
      </tr>
    </table>
  </div>
</div>

{#if photo != undefined}
  <div class="photo">
    <img src="{pathFilesSport}{photo}" alt="" width="75%" height="75%" />
  </div>
  {tabSelectImage}

  <div>
    {#if visible}
        {#each brutRows as row}
        <img src="{pathFilesSport}{row}" alt="" width="45%" height="45%" /><br/>
        {/each}
     {/if}
  </div>
{/if}

<style>
  .exec {
    color: green;
  }
  .repos {
    color: red;
  }
  .chiffre {
    text-align: center;
    font-size: 138px;
    font-weight: bold;
  }
  .compteur {
    text-align: center;
    font-size: 80px;
    font-weight: bold;
  }
  .btnchrono {
    font-size: 20px;
  }
  .photo {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
</style>
